export const LANDING = '/';
export const FLOWERSOFBAD = '/flowersofbad';
export const POEM = '/poems/:poemId';
export const TOC = '/toc';
export const ABOUT = '/about';
export const AFTERWORD = '/afterword';
export const POEMFORM = '/form';
export const POEMEDIT = '/edit';
